import React from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import styles from './styles/DownloadButtonsStyles';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';

import excelImg from 'Content/Assets/images/excel-icon_20.png';
import pdfImg from 'Content/Assets/images/PDF_original.png';
import ButtonLoaderWithText from 'components/loaders/ButtonLoaderWithText';
import { downloadSingleExcel, downloadSinglePdf, downloadSingleCsv } from 'actions/crashboxxServicesActions';

class DownloadButtons extends React.Component {
    constructor(props){
        super(props);

        this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleDownloadCsv = this.handleDownloadCsv.bind(this);
    }

    handleDownloadExcel(){
        this.props.downloadSingleExcel(this.props.id, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadPdf(){
        this.props.downloadSinglePdf(this.props.id, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadCsv(){
        this.props.downloadSingleCsv(this.props.id, this.props.isIcnPlus, this.props.isDent);
    }

    render() {

        console.info("download button rendered");

        const {translate, isPdfLoading, isExcelLoading, isCsvLoading} = this.props;

        return (
            <Paper style={styles.container} >
                {
                    isPdfLoading ? <ButtonLoaderWithText />
                    :
                    <FlatButton label={translate('Download.downloadPDF')}
                        onClick={this.handleDownloadPdf}
                        icon={ <Avatar
                                src={pdfImg}
                                size={25}
                                style={styles.imageIcon}
                            /> } >
                    </FlatButton>


                }
                {
                    isExcelLoading ? <ButtonLoaderWithText />
                    :
                    <FlatButton label={translate('Download.downloadExcel')} onClick={this.handleDownloadExcel}
                        icon={ <Avatar
                                src={excelImg}
                                size={25}
                                style={styles.imageIcon}
                            /> } >
                    </FlatButton>
                }
                {
                    isCsvLoading ? <ButtonLoaderWithText />
                    :
                    <FlatButton label={translate('Download.downloadCSV')}  onClick={this.handleDownloadCsv}
                        icon={ <Avatar
                                    src={excelImg}
                                    size={25}
                                    style={styles.imageIcon}
                                /> } >
                    </FlatButton>
                }


            </Paper>
        );
    }
}

DownloadButtons.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        isExcelLoading: state.singleExcel.isLoading,
        isPdfLoading: state.singlePdf.isLoading,
        isCsvLoading: state.singleCsv.isLoading
    }
}
export default connect(mapStateToProps, {downloadSingleExcel, downloadSinglePdf, downloadSingleCsv})(DownloadButtons);


// WEBPACK FOOTER //
// ./src/containers/downloadButtons/DownloadButtons.js